module.exports = __webpack_public_path__ + "img/storm-panel-shutter-pricing.e2aa4cfd.jpg";